import { Alert, Typography } from '@mui/material';
import styles from './Firmateckning.module.css';

interface FirmateckningProps {
  signatures: string[];
}

export const Firmateckning: React.FC<FirmateckningProps> = ({
  signatures = [],
}) => (
  <div>
    <h3>Firmateckning</h3>
    {signatures.length ? (
      <pre className={styles.firmateckning}>
        <Typography>
          {signatures
            ?.filter((signature) => signature)
            .map((signature) => signature.replace(/_/g, ''))
            .join('\n')}
        </Typography>
      </pre>
    ) : (
      <Alert severity="info">Ingen firmateckning hittades.</Alert>
    )}
  </div>
);
